import { replace } from 'lodash';
import numeral from 'numeral';

// ----------------------------------------------------------------------

export function fCurrency(number) {
  return numeral(number).format(Number.isInteger(number) ? '$0,0' : '$0,0.00');
}

export function fCurrencyWithDomain(number, domain = null) {
  // Get current domain if not provided
  if (!domain) {
    const hostSubArray = window.location.host.split(".");
    domain = hostSubArray[hostSubArray.length - 2];
  }
  
  // Use Rs for all domains except avvtech
  const currencySymbol = domain === 'avvtech' ? '$' : 'Rs';
  return numeral(number).format(Number.isInteger(number) ? `${currencySymbol}0,0` : `${currencySymbol}0,0.00`);
}

export function fPercent(number) {
  return numeral(number / 100).format('0.0%');
}

export function fNumber(number) {
  return numeral(number).format();
}

export function fShortenNumber(number) {
  return replace(numeral(number).format('0.00a'), '.00', '');
}

export function fData(number) {
  return numeral(number).format('0.0 b');
}

// Dashboard energy: "12.5 kWh", "184.53 MWh", "1.20 GWh". Shared so every card
// shows the same precision and units.
export function fEnergy(value) {
  const n = Number(value) || 0;
  const a = Math.abs(n);
  if (a >= 1e6) return `${(n / 1e6).toFixed(2)} GWh`;
  if (a >= 1e3) return `${(n / 1e3).toFixed(2)} MWh`;
  return `${n.toFixed(1)} kWh`;
}

// Dashboard money (INR): "₹1,234.5", "₹2.40 L", "₹1.10 Cr".
export function fMoneyShort(value) {
  const n = Number(value) || 0;
  const a = Math.abs(n);
  if (a >= 1e7) return `₹${(n / 1e7).toFixed(2)} Cr`;
  if (a >= 1e5) return `₹${(n / 1e5).toFixed(2)} L`;
  return `₹${n.toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
}
